import React from 'react';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CommonTable from '../../common/components/CommonTable';
import InvoiceTransactionsTableRow from './InvoiceTransactionsTableRow';

const headers = [
  { label: 'ID' },
  { label: 'Amount' },
  { label: 'Title' },
  { label: 'Creation Date' },
  { label: 'Payment status' },
];

function InvoiceTransactionsTable({ items, invoiceStatus }) {
  const data = { items: items || [], total: (items || []).length };

  return (
    <Row>
      <Col xs="12">
        <CommonTable
          rowComponent={InvoiceTransactionsTableRow}
          rowComponentProps={{ invoiceStatus }}
          data={data}
          offset={0}
          onOffsetChange={() => {}}
          headers={headers}
          title="Invoice Transactions"
          hasRowPointer={false}
          pagination={false}
        />
      </Col>
    </Row>
  );
}

InvoiceTransactionsTable.propTypes = {
  items: PropTypes.array,
  invoiceStatus: PropTypes.string,
};

InvoiceTransactionsTable.defaultProps = {
  items: [],
  invoiceStatus: 'PAID',
};

export default InvoiceTransactionsTable;
